import React from "react";
import Form from "./VoiceManagementForm";
import { connect } from "react-redux";
import { createVoiceManagement } from "../fetchAPI/apiClient";
const Create = (props) => {
  const onSubmit = async (values) => {
    let formData = new FormData();
    formData.append("company_id", props.profile.company_id);
    formData.append("user_id", props.profile.id);
    formData.append("name", values["name"]);
    formData.append("remark", values["remark"]);
    formData.append("upload_type", values["upload_type"]);
    // 🔥 Convert URL to File
    const response = await fetch(values.upload);
    const blob = await response.blob();

    // สร้างชื่อไฟล์ (หรือจะใช้ values.name + ".mp3" ก็ได้)
    const file = new File([blob], "tts.mp3", { type: "audio/mpeg" });

    // แนบเข้า FormData
    formData.append("file", file);

    createVoiceManagement(formData, (statusCode, response) => {
      if (response.data.status === 200) {
        window.location.replace("/voice-management");
      }
    });
  };
  return (
    <Form
      type="create"
      match={props.match}
      onSubmit={onSubmit}
      profile={props.profile}
    />
  );
};

export default connect(
  ({ auth, auth: { profile } }) => ({
    auth,
    profile,
  }),
  {}
)(Create);
